import { Component, OnInit, Input } from '@angular/core';
import { RegeneratedPermitResult, DocumentUploadStatus } from "../../../../common/models/permit.model";



@Component({
    selector: 'upload-status',
    templateUrl: './upload-status.component.html',
    styleUrls: ['./upload-status.component.scss'],
    standalone: false
})
export class UploadStatusComponent implements OnInit {

    statuses = DocumentUploadStatus;

    @Input() document: RegeneratedPermitResult;

    constructor() { }

    ngOnInit() {
    }

}
